import type { RestaurantEventAddOn } from '@shared/types/restaurantEvents';
import { centsToWholeDollar } from '@shared/utils/currency';
import { getRestaurantImagePath } from '@shared/utils/getRestaurantImagePath';
import cx from 'classnames';
import typography from '~styles/typography.scss';
import styles from './AddOnCard.scss';

interface AddOnCardProps {
  addOn: RestaurantEventAddOn;
  quantity: number;
  onIncrement: () => void;
  onDecrement: () => void;
}

export const AddOnCard = ({
  addOn,
  quantity,
  onIncrement,
  onDecrement,
}: AddOnCardProps) => {
  const isSelected = quantity > 0;
  const imageUrl = addOn.imageKey && getRestaurantImagePath(addOn.imageKey);

  return (
    <div className={cx(styles.card, { [styles.selected]: isSelected })}>
      {isSelected && (
        <div className={styles.quantityBadge}>
          <button
            type="button"
            className={styles.quantityButton}
            onClick={onDecrement}
            aria-label="Decrease quantity"
          >
            −
          </button>
          <span className={typography.c2}>{quantity}</span>
          <button
            type="button"
            className={styles.quantityButton}
            onClick={onIncrement}
            aria-label="Increase quantity"
          >
            +
          </button>
        </div>
      )}
      <button
        type="button"
        className={styles.selectButton}
        onClick={onIncrement}
      >
        {imageUrl && (
          <div
            className={styles.addOnImage}
            style={{
              backgroundImage: `url(${imageUrl})`,
            }}
          ></div>
        )}
        <div className={styles.content}>
          <div className={styles.nameAndDescription}>
            <span className={cx(typography.c3_20, styles.name)}>
              {addOn.name}
            </span>
            <span className={cx(typography.t2, styles.description)}>
              {addOn.description}
            </span>
          </div>
          <span className={cx(typography.h7m, styles.price)}>
            {addOn.price > 0 ? centsToWholeDollar(addOn.price) : 'Free'}
          </span>
        </div>
      </button>
    </div>
  );
};
